//export const dispatchCategoryId = 1;
//export const driverCategoryId = 8;
//export const equipmentCategoryId = 35;
//export const shiftCategoryId = 51;
//export const hrCategoryId = 41;

export const fleetDepartmentOptions = [
	{
		isGroup: true,
		display: 'In House',
	},
	{
		display: 'Billing Department',
		value: 'billing',
	},
	{
		display: 'Safety Department',
		value: 'safety',
	},
	{
		display: 'General Office / Dispatch / Fleet',
		value: 'dispatch',
	},
	{
		isGroup: 'Driver',
		display: 'Drivers & Mechanics',
	},
	{
		display: 'Colton (COL)',
		value: 'colton',
	},
	{
		display: 'Paramount (LA) / Montebello (MB) / Huntington Beach (HB)',
		value: 'paramount',
	},
	{
		display: 'Portland (PDX)',
		value: 'portland',
	},
	{
		display: 'Eugene (EUG)',
		value: 'eugene',
	},
	{
		display: 'Phoenix (PHX)',
		value: 'phoenix',
	},
	{
		display: 'Tacoma (TAC / KENT / SEA)',
		value: 'tacoma',
	},
	{
		display: 'Ferndale (FERN)',
		value: 'ferndale',
	},
	{
		display: 'San Diego (SD)',
		value: 'sandiego',
	},
	{
		display: 'Long Beach (LB)',
		value: 'longbeach',
	},
];

const mariaL = 391;
const dougK = 411;
const carrierF = 413;
const silviaC = 390;
const JOEP = 373;
//const ALFREDO_LAURIAN = 415;
const JOHNNY_REYES = 402;
const MARK_VAN_OSDOL = 396;
const JERROD_USER_ID = 398;
// const JOEY_USER_ID = 377;
const DANIEL_ANDERSON_ID = 378;

// COLTON
const CESAR_MONTOYA = 444;
//const RAUL_CANTERO = 408;

const COLTON_TERMINAL_MANAGER = CESAR_MONTOYA;
//const COLTON_TERMINAL_MANAGER = RAUL_CANTERO;

export const fleetDepartmentToTerminalManagerUserId = {
	colton: COLTON_TERMINAL_MANAGER,
	sandiego: COLTON_TERMINAL_MANAGER,
	paramount: JOHNNY_REYES,
	longbeach: JOHNNY_REYES,
	portland: JERROD_USER_ID,
	eugene: JERROD_USER_ID,
	phoenix: COLTON_TERMINAL_MANAGER,
	tacoma: MARK_VAN_OSDOL,
	ferndale: MARK_VAN_OSDOL,
	billing: silviaC,
	safety: JOEP,
	// dispatch: JOEY_USER_ID,
	dispatch: DANIEL_ANDERSON_ID,
};

export const userIdToManagerUserId = {
	[mariaL]: dougK,
	[silviaC]: dougK,
	[carrierF]: dougK,
	[dougK]: dougK,
};

export const fleetDepartmentToTerminalAdminUserId = {
	colton: 410,
	sandiego: 410,
	//paramount : 400, Jacob Smith
	paramount: 455, //- Andrew Hernandez
	longbeach: 455,
	portland: undefined,
	eugene: undefined,
	phoenix: 410,
	tacoma: undefined,
	ferndale: undefined,
	billing: undefined,
	safety: undefined,
	dispatch: undefined,
};

export const fleetDepartmentToMechUserId = {
	colton: 437,
	sandiego: 437,
	paramount: 436,
	longbeach: 436,
	portland: 439,
	eugene: 439,
	phoenix: 437,
	tacoma: 438,
	ferndale: 438,
};

//
//- Kinda deprecated since use use fleetDepartment now
//
export const fleetToManagerUserId = {
	//COL : 394,
	COL: COLTON_TERMINAL_MANAGER, //- Cesar M
	SD: COLTON_TERMINAL_MANAGER, //- Cesar M
	HB: JOHNNY_REYES,
	LA: JOHNNY_REYES,
	LB: JOHNNY_REYES,
	MB: JOHNNY_REYES,
	PDX: JERROD_USER_ID,
	EUG: JERROD_USER_ID,
	PHX: COLTON_TERMINAL_MANAGER,
	SEA: MARK_VAN_OSDOL,
	TAC: MARK_VAN_OSDOL,
	FERN: MARK_VAN_OSDOL,
};

/*
export const fleetToMechUserId = {
	COL : 437,
	HB : 436,
	LA : 436,
	MB : 436,
	PDX : 439,
	SEA : 438,
	TAC : 438,
	FERN : 438,
};
*/

/*
export const roleToUserId = {
	safety : 373,
};
*/
